import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { FaCheck, FaTimes } from "react-icons/fa";
import { connect } from "react-redux";
import { setCrop } from "../../../../_actions/textToolbarActions";
import { TldrCollapsableAction } from "../../../common/statelessView";
import TldrCollpasibleSection from "../../../common/TldrCollpasibleSection";
import {
  StyledLayoutCollection,
  StyledSlideLayout,
} from "../../../styled/details/stylesDetails";
import { white } from "../../../styled/variable";
import { AVAILABLE_SHAPES_FOR_CLIP } from "../../constants";

class TldrImageClipShapes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapse: false,
      localShape: "",
    };
  }

  componentWillUnmount() {
    if (this.props.canvasRef.handler?.clipHandler.clipRect) {
      this.applyClip();
    }
  }

  render() {
    const { collapse, localShape } = this.state;
    const { activeElement } = this.props.editor;
    const { t } = this.props;
    const availableShapes = AVAILABLE_SHAPES_FOR_CLIP.map((shape, index) => {
      return (
        <StyledSlideLayout
          key={index}
          onClick={() => this.onChangeClipShape(shape)}
          className={localShape === shape ? "active" : ""}
        >
          <div className={`${shape}`} />
        </StyledSlideLayout>
      );
    });
    const actionsView = (
      <>
        <TldrCollapsableAction
          icon={<FaCheck />}
          action={activeElement.mime}
          callback={this.applyClip}
          title={t("cropping.clip_img")}
          iconColor={white}
          disabled={!this.props.canvasRef.handler?.clipHandler.clipRect}
        ></TldrCollapsableAction>
        <TldrCollapsableAction
          icon={<FaTimes />}
          action={activeElement.mime}
          callback={this.cancelClip}
          title={t("cropping.cancel_clip")}
          iconColor={white}
          disabled={!this.props.canvasRef.handler?.clipHandler.clipRect}
        ></TldrCollapsableAction>
      </>
    );

    return (
      <TldrCollpasibleSection
        title={t("cropping.clipping_shape")}
        collapse={collapse}
        onToggleCollapse={this.handleToggleChange}
        toggleButton={actionsView}
      >
        <StyledLayoutCollection location="clip">
          {availableShapes}
        </StyledLayoutCollection>
      </TldrCollpasibleSection>
    );
  }

  onChangeClipShape = (shape) => {
    const { canvasRef } = this.props;
    const { clipHandler } = canvasRef.handler;

    this.setState({ localShape: shape });
    clipHandler.start(shape);
  };

  handleToggleChange = () => {
    this.setState({ collapse: !this.state.collapse });
  };

  applyClip = (action) => {
    const { canvasRef } = this.props;
    const { clipHandler } = canvasRef.handler;

    clipHandler.finish();
    this.props.setCrop(false);
  };

  cancelClip = (action) => {
    const { canvasRef } = this.props;
    const { clipHandler } = canvasRef.handler;

    clipHandler.cancel(false);
    this.props.setCrop(false);
  };
}

TldrImageClipShapes.propTypes = {};

const mapStateToProps = (state) => ({
  editor: state.editor,
});

const mapDispatchToProps = (dispatch) => ({
  setCrop: (isEnable) => dispatch(setCrop(isEnable)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(["common"])(TldrImageClipShapes));
